import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  root: {
    height: 'calc(100vh - 20px)',
    paddingTop: "100px",
    paddingBottom: "150px",
    paddingLeft: '350px',
    backgroundColor: "#f0f3f5",
    position: "relative", 
    [theme.breakpoints.down('md')]: {
      height: '2000px'
    }
  },
  newButton1: {
    position: "absolute",
    top: "45%",
    right: "50px",
    fontFamily: 'Montserrat', 
    fontSize: '16px', 
    backgroundColor: 'rgb(111, 89, 166)',
    color: 'white', 
    fontWeight: 'bold', 
    padding: '10px 20px',
    width: '340px',
    '&:hover': {
      backgroundColor: '#b499d7'
    }
  },
  imageButton: {
    position: "absolute",
    top: "0",
    right: "50px",
    // height: '50px', 
    // width: '50px',
    cursor: 'pointer', 
    [theme.breakpoints.down('md')]: {
      left: '40px !important',
      top: '170px'
    }
  },
  imageButton1: {
    position: "absolute",
    top: "35%",
    right: "50px",
    marginTop:"3px",
    // height: '50px', 
    // width: '50px',
    cursor: 'pointer', 
    [theme.breakpoints.down('md')]: {
      left: '40px !important', 
      top: '150px'
    }
  },
  absoluteTop: {
    position: 'absolute', 
    top: '20px', 
    left: '50%', 
    transform: 'translateX(-50%)',
    width: '100%',
    [theme.breakpoints.down('md')]: {
      width: '80%',
      transform: 'translateX(-70%)'
    }
  },
  headingOne: {
    fontFamily: "Montserrat",
    fontWeight: "bold",
    color: '#262838',
    fontSize: "18px",
    [theme.breakpoints.down('md')]: {
      fontSize: '28px',
    }
  },
  headingTwo: {
    fontFamily: "Montserrat",
    color: "#6f59a6",
    fontSize: "40px",
    fontWeight: "bold",
    [theme.breakpoints.down('md')]: {
      fontSize: '26px '
    }
  },
  newButton: {
    position: "absolute",
    top: "0",
    right: "50px",
    fontFamily: 'Montserrat', 
    fontSize: '16px', 
    backgroundColor: 'rgb(111, 89, 166)',
    color: 'white', 
    fontWeight: 'bold', 
    padding: '10px 20px',
    width: '340px',
    '&:hover': {
      backgroundColor: '#b499d7'
    }
  },
  objectFit:{
    objectFit: 'contain', 
    backgroundColor: 'white', 
    marginRight: '20px',
  },
  tooltip: {
    backgroundColor: "rgba(118,95,170,1)",
    padding: "10px",
    maxWidth: "none",
  },
  tooltipArrow: {
    backgroundColor: "rgba(118,95,170,1)",
  },
}));

export default useStyles;
